import { useAiChatAttached } from '@euler/app/flows/ai-suite/chat/AiChatActions';
import { CardNotice } from '@euler/app/flows/ai-suite/components/ChatCard';
import { PrimaryButton } from '@euler/app/flows/ai-suite/components/PrimaryButton';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { BiAnswerAction } from '@euler/model/bi/answer';
import { CirclePlus } from 'lucide-react-native';
import { memo } from 'react';
import { View } from 'react-native';
import { useBiTap } from '../bi-visualization/functions/useBiTap';
import { BiProposalSelection } from './functions/useBiProposalSelection';

/** Mirror of backend `kBiMaxDraftsPerAdd`: drafts one add may carry. */
const kMaxPerAdd = 20;

/**
 * **Add selected to dashboard**: one `add` tap with the ticked drafts, in
 * the card's order; the reply asks where when it has to.
 */
export const BiProposalAddButton = memo(
  ({
    draftIds,
    selection,
  }: {
    /** Every proposal of the card, in its order. */
    draftIds: string[];
    selection: BiProposalSelection;
  }) => {
    const { rpx } = useResponsiveContext();
    const attached = useAiChatAttached();
    // Once the add is settled the tiles say where each went.
    const { pending, busy, tap } = useBiTap(selection.clear);
    const chosen = draftIds.filter(id => selection.selected.includes(id));
    if (!attached) return null;
    const tooMany = chosen.length > kMaxPerAdd;
    return (
      <View style={{ gap: rpx(6) }}>
        {tooMany ? (
          <CardNotice
            tone="danger"
            text={`一次最多加 ${kMaxPerAdd} 张图表，请少选几张。`}
          />
        ) : null}
        <PrimaryButton
          title={
            chosen.length
              ? `把选中的 ${chosen.length} 张加到看板`
              : '勾选图表，加到看板'
          }
          icon={CirclePlus}
          loading={!!pending}
          disabled={busy || !chosen.length || tooMany}
          onPress={() => {
            tap({ action: BiAnswerAction.Add, draftIds: chosen });
          }}
        />
      </View>
    );
  },
);
